import { render, staticRenderFns } from "./import_form.vue?vue&type=template&id=088f639b&scoped=true"
import script from "./import_form.vue?vue&type=script&lang=js"
export * from "./import_form.vue?vue&type=script&lang=js"
import style0 from "./import_form.vue?vue&type=style&index=0&id=088f639b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088f639b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('088f639b')) {
      api.createRecord('088f639b', component.options)
    } else {
      api.reload('088f639b', component.options)
    }
    module.hot.accept("./import_form.vue?vue&type=template&id=088f639b&scoped=true", function () {
      api.rerender('088f639b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal_order/terminal_fee/form/import_form.vue"
export default component.exports